import { create } from "zustand";


const initialProCards = [
    {
        proCardId: 23,
        amount: 23.34,
        itemPurpose: "Item Purpose 1",
        trackingNumber: "2234366754324543",
        transactionDate: "2024-03-01",
        expenditureTypeId: "1",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",
        receipts: []
    },
    {
        proCardId: 33,
        amount: 44.00,
        itemPurpose: "Item Purpose 2",
        trackingNumber: "2234366754324543",
        transactionDate: "2024-03-01",
        expenditureTypeId: "2",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",
        receipts: []
    },
    {
        proCardId: 122,
        amount: 110.12,
        itemPurpose: "Item Purpose 3",
        trackingNumber: "2234366754324543",
        transactionDate: "2024-03-01",
        expenditureTypeId: "1",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",
        receipts: []
    },
    {
        proCardId: 2,
        amount: 1.02,
        itemPurpose: "Item Purpose 4",
        trackingNumber: "2234366754324543",
        transactionDate: "2024-03-01",
        expenditureTypeId: "2",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",
        receipts: []
    },
    {
        proCardId: 323,
        amount: 30.00,
        itemPurpose: "Item Purpose 5",
        trackingNumber: "2234366754324543",
        transactionDate: "2024-03-01",
        expenditureTypeId: "1",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",
        receipts: []
    },
    {
        proCardId: 88,
        amount: 65.99,
        itemPurpose: "Item Purpose 6",
        trackingNumber: "2234366754324543",
        transactionDate: "2024-03-01",
        expenditureTypeId: "2",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",
        receipts: []
    },
    {
        proCardId: 11,
        amount: 1.34,
        itemPurpose: "Item Purpose 7",
        trackingNumber: "2234366754324543",
        transactionDate: "2024-03-01",
        expenditureTypeId: "1",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",
        receipts: []
    },
    {
        proCardId: 999,
        amount: 58.99,
        itemPurpose: "Item Purpose 8",
        trackingNumber: "2234366754324543",
        transactionDate: "2024-03-01",
        expenditureTypeId: "2",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",
        receipts: []
    },
];



const initialChecks = [

    {

        checkId: 1,
        checkTypeId: "2",
        amount: 122.54,
        expenditureTypeId: "1",
        itemPurpose: "This is an item purpose",
        checkDate: "2025-01-01",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",



        lineItems: [
            {
                lineItemId: 1,
                categoryId: 12,
                description: "This is a description",
                amount: 33.34,
                localKey: "fgdhfdghjdhgfh",
            },
            {
                lineItemId: 2,
                categoryId: 23,
                description: "This is a description",
                amount: 45.99,
                localKey: "jyhkii",
            },
            {
                lineItemId: 3,
                categoryId: 6,
                description: "This is a description",
                amount: 1.90,
                localKey: "bbnhkkll",
            },
            {
                lineItemId: 4,
                categoryId: 11,
                description: "This is a description",
                amount: 77.00,
                localKey: "dgdhjfgjfukukuk",
            },
        ]

    },
    {

        checkId: 2,
        checkTypeId: "3",
        amount: 122.54,
        expenditureTypeId: "1",
        itemPurpose: "This is an item purpose",
        checkDate: "2025-01-01",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",



        lineItems: [
            {
                lineItemId: 1,
                categoryId: 12,
                description: "This is a description",
                amount: 33.34,
                localKey: "fgdhfdghjdhgfh",
            },
            {
                lineItemId: 2,
                categoryId: 23,
                description: "This is a description",
                amount: 45.99,
                localKey: "jyhkii",
            },
            {
                lineItemId: 3,
                categoryId: 6,
                description: "This is a description",
                amount: 1.90,
                localKey: "bbnhkkll",
            },
            {
                lineItemId: 4,
                categoryId: 11,
                description: "This is a description",
                amount: 77.00,
                localKey: "dgdhjfgjfukukuk",
            },
        ]

    },
    {

        checkId: 3,
        checkTypeId: "1",
        amount: 122.54,
        expenditureTypeId: "2",
        itemPurpose: "This is an item purpose",
        checkDate: "2025-01-01",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",



        lineItems: [
            {
                lineItemId: 1,
                categoryId: 12,
                description: "This is a description",
                amount: 33.34,
                localKey: "fgdhfdghjdhgfh",
            },
            {
                lineItemId: 2,
                categoryId: 23,
                description: "This is a description",
                amount: 45.99,
                localKey: "jyhkii",
            },
            {
                lineItemId: 3,
                categoryId: 6,
                description: "This is a description",
                amount: 1.90,
                localKey: "bbnhkkll",
            },
            {
                lineItemId: 4,
                categoryId: 11,
                description: "This is a description",
                amount: 77.00,
                localKey: "dgdhjfgjfukukuk",
            },
        ]

    },
    {

        checkId: 4,
        checkTypeId: "1",
        amount: 122.54,
        expenditureTypeId: "1",
        itemPurpose: "This is an item purpose",
        checkDate: "2025-01-01",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",



        lineItems: [
            {
                lineItemId: 1,
                categoryId: 12,
                description: "This is a description",
                amount: 33.34,
                localKey: "fgdhfdghjdhgfh",
            },
            {
                lineItemId: 2,
                categoryId: 23,
                description: "This is a description",
                amount: 45.99,
                localKey: "jyhkii",
            },
            {
                lineItemId: 3,
                categoryId: 6,
                description: "This is a description",
                amount: 1.90,
                localKey: "bbnhkkll",
            },
            {
                lineItemId: 4,
                categoryId: 11,
                description: "This is a description",
                amount: 77.00,
                localKey: "dgdhjfgjfukukuk",
            },
        ]

    },
    {

        checkId: 5,
        checkTypeId: "2",
        amount: 122.54,
        expenditureTypeId: "1",
        itemPurpose: "This is an item purpose",
        checkDate: "2025-01-01",


        vendorName: "Vendor 1",
        vendorAddress: "Main Street",
        vendorCity: "Lexington",
        vendorState: 54,
        vendorZip: "55555",
        vendorPhone: "555-555-5555",
        vendorNote: "This is a note",

        comments: "This is a comment",



        lineItems: [
            {
                lineItemId: 1,
                categoryId: 12,
                description: "This is a description",
                amount: 33.34,
                localKey: "fgdhfdghjdhgfh",
            },
            {
                lineItemId: 2,
                categoryId: 23,
                description: "This is a description",
                amount: 45.99,
                localKey: "jyhkii",
            },
            {
                lineItemId: 3,
                categoryId: 6,
                description: "This is a description",
                amount: 1.90,
                localKey: "bbnhkkll",
            },
            {
                lineItemId: 4,
                categoryId: 11,
                description: "This is a description",
                amount: 77.00,
                localKey: "dgdhjfgjfukukuk",
            },
        ]

    }
];



const initialRefunds = [
    {

        refundId: 1,
        receivedById: "dsfadsf",
        receivedByDate: "2025-01-02",
        comments: "This is a comment",

        amount: 45.30,
        checkNumber: "64564568",
        from: "From Me",
        address: "Main Street",
        city: "Lexington",
        state: 54,
        zip: "55555",
        phone: "555-555-5555",
        checkTypeId: "2",
        payToId: "1",
        relatedToId: 0,

        releasedToMfpAdminId: "dsfadsf",
        releasedToMfpAdminDate: "2025-01-02",

        releasedToCopAdminId: "tyer",
        releasedToCopAdminDate: "2025-01-02",

        lineItems: [
            {
                lineItemId: 1,
                categoryId: 12,
                description: "This is a description",
                amount: 33.34,
                localKey: "fgdhfdghjdhgfh",
            },
            {
                lineItemId: 2,
                categoryId: 23,
                description: "This is a description",
                amount: 45.99,
                localKey: "jyhkii",
            },
            {
                lineItemId: 3,
                categoryId: 6,
                description: "This is a description",
                amount: 1.90,
                localKey: "bbnhkkll",
            },
            {
                lineItemId: 4,
                categoryId: 11,
                description: "This is a description",
                amount: 77.00,
                localKey: "dgdhjfgjfukukuk",
            },
        ]
    },
    {

        refundId: 2,
        receivedById: "dsfadsf",
        receivedByDate: "2025-01-02",
        comments: "This is a comment",

        amount: 45.30,
        checkNumber: "64564568",
        from: "From Me",
        address: "Main Street",
        city: "Lexington",
        state: 54,
        zip: "55555",
        phone: "555-555-5555",
        checkTypeId: "2",
        payToId: "1",
        relatedToId: 0,

        releasedToMfpAdminId: "dsfadsf",
        releasedToMfpAdminDate: "2025-01-02",

        releasedToCopAdminId: "tyer",
        releasedToCopAdminDate: "2025-01-02",

        lineItems: [
            {
                lineItemId: 1,
                categoryId: 12,
                description: "This is a description",
                amount: 33.34,
                localKey: "fgdhfdghjdhgfh",
            },
            {
                lineItemId: 2,
                categoryId: 23,
                description: "This is a description",
                amount: 45.99,
                localKey: "jyhkii",
            },
            {
                lineItemId: 3,
                categoryId: 6,
                description: "This is a description",
                amount: 1.90,
                localKey: "bbnhkkll",
            },
            {
                lineItemId: 4,
                categoryId: 11,
                description: "This is a description",
                amount: 77.00,
                localKey: "dgdhjfgjfukukuk",
            },
        ]
    },
    {

        refundId: 3,
        receivedById: "dsfadsf",
        receivedByDate: "2025-01-02",
        comments: "This is a comment",

        amount: 45.30,
        checkNumber: "64564568",
        from: "From Me",
        address: "Main Street",
        city: "Lexington",
        state: 54,
        zip: "55555",
        phone: "555-555-5555",
        checkTypeId: "2",
        payToId: "1",
        relatedToId: 0,

        releasedToMfpAdminId: "dsfadsf",
        releasedToMfpAdminDate: "2025-01-02",

        releasedToCopAdminId: "tyer",
        releasedToCopAdminDate: "2025-01-02",

        lineItems: [
            {
                lineItemId: 1,
                categoryId: 12,
                description: "This is a description",
                amount: 33.34,
                localKey: "fgdhfdghjdhgfh",
            },
            {
                lineItemId: 2,
                categoryId: 23,
                description: "This is a description",
                amount: 45.99,
                localKey: "jyhkii",
            },
            {
                lineItemId: 3,
                categoryId: 6,
                description: "This is a description",
                amount: 1.90,
                localKey: "bbnhkkll",
            },
            {
                lineItemId: 4,
                categoryId: 11,
                description: "This is a description",
                amount: 77.00,
                localKey: "dgdhjfgjfukukuk",
            },
        ]
    },
    {

        refundId: 4,
        receivedById: "dsfadsf",
        receivedByDate: "2025-01-02",
        comments: "This is a comment",

        amount: 45.30,
        checkNumber: "64564568",
        from: "From Me",
        address: "Main Street",
        city: "Lexington",
        state: 54,
        zip: "55555",
        phone: "555-555-5555",
        checkTypeId: "2",
        payToId: "1",
        relatedToId: 0,

        releasedToMfpAdminId: "dsfadsf",
        releasedToMfpAdminDate: "2025-01-02",

        releasedToCopAdminId: "tyer",
        releasedToCopAdminDate: "2025-01-02",

        lineItems: [
            {
                lineItemId: 1,
                categoryId: 12,
                description: "This is a description",
                amount: 33.34,
                localKey: "fgdhfdghjdhgfh",
            },
            {
                lineItemId: 2,
                categoryId: 23,
                description: "This is a description",
                amount: 45.99,
                localKey: "jyhkii",
            },
            {
                lineItemId: 3,
                categoryId: 6,
                description: "This is a description",
                amount: 1.90,
                localKey: "bbnhkkll",
            },
            {
                lineItemId: 4,
                categoryId: 11,
                description: "This is a description",
                amount: 77.00,
                localKey: "dgdhjfgjfukukuk",
            },
        ]
    },
    {

        refundId: 5,
        receivedById: "dsfadsf",
        receivedByDate: "2025-01-02",
        comments: "This is a comment",

        amount: 45.30,
        checkNumber: "64564568",
        from: "From Me",
        address: "Main Street",
        city: "Lexington",
        state: 54,
        zip: "55555",
        phone: "555-555-5555",
        checkTypeId: "2",
        payToId: "1",
        relatedToId: 0,

        releasedToMfpAdminId: "dsfadsf",
        releasedToMfpAdminDate: "2025-01-02",

        releasedToCopAdminId: "tyer",
        releasedToCopAdminDate: "2025-01-02",

        lineItems: [
            {
                lineItemId: 1,
                categoryId: 12,
                description: "This is a description",
                amount: 33.34,
                localKey: "fgdhfdghjdhgfh",
            },
            {
                lineItemId: 2,
                categoryId: 23,
                description: "This is a description",
                amount: 45.99,
                localKey: "jyhkii",
            },
            {
                lineItemId: 3,
                categoryId: 6,
                description: "This is a description",
                amount: 1.90,
                localKey: "bbnhkkll",
            },
            {
                lineItemId: 4,
                categoryId: 11,
                description: "This is a description",
                amount: 77.00,
                localKey: "dgdhjfgjfukukuk",
            },
        ]
    }
];

const newIdProCards = (collection) => {

    const ids = collection.map(x => x.proCardId);

    let newId = -1;
    while (newId == -1 || ids.includes(newId)) {
        newId = Math.round(Math.random() * 1000);
    }

    return newId;
};

const newIdChecks = (collection) => {
    const ids = collection.map(x => x.checkId);

    let newId = -1;
    while (newId == -1 || ids.includes(newId)) {
        newId = Math.round(Math.random() * 1000);
    }

    return newId;
};

const newIdRefunds = (collection) => {
    const ids = collection.map(x => x.refundId);

    let newId = -1;
    while (newId == -1 || ids.includes(newId)) {
        newId = Math.round(Math.random() * 1000);
    }

    return newId;
};

const initialState = {
    proCards: initialProCards,
    checks: initialChecks,
    refunds: initialRefunds
};

const useTestExpenditureData = create((set, get) => ({

    ...initialState,

    proCardActions: {
        add: (proCard) => set({ proCards: [...get().proCards, { ...proCard, proCardId: newIdProCards(get().proCards) }] }),
        replace: (proCard) => {
            const current = get().proCards;
            const index = current.findIndex(x => x.proCardId == proCard.proCardId);
            current.splice(index, 1, proCard);
            set({ proCards: [...current] });
        },
        remove: (id) => {
            const current = get().proCards;
            const index = current.findIndex(x => x.proCardId == id);
            current.splice(index, 1);
            set({ proCards: [...current] });
        }
    },

    checkActions: {
        add: (check) => set({ checks: [...get().checks, { ...check, checkId: newIdChecks(get().checks) }] }),
        replace: (check) => {
            const current = get().checks;
            const index = current.findIndex(x => x.checkId == check.checkId);
            current.splice(index, 1, check);
            set({ checks: [...current] });
        },
        remove: (id) => {
            const current = get().checks;
            const index = current.findIndex(x => x.checkId == id);
            current.splice(index, 1);
            set({ checks: [...current] });
        }
    },

    refundActions: {
        add: (refund) => set({ refunds: [...get().refunds, { ...refund, refundId: newIdRefunds(get().refunds) }] }),
        replace: (refund) => {
            const current = get().refunds;
            const index = current.findIndex(x => x.refundId == refund.refundId);
            current.splice(index, 1, refund);
            set({ refunds: [...current] });
        },
        remove: (id) => {
            const current = get().refunds;
            const index = current.findIndex(x => x.refundId == id);
            current.splice(index, 1);
            set({ refunds: [...current] });
        }
    }


}));


export default useTestExpenditureData;